/**
 * @ngdoc service
 * @name BB:BBWidgetRoutes
 *
 * @description
 * Representation of an BBWidgetRoutes Object
 *
 * @property {integer} steps Step information
 */

class BBWidgetRoutesService {
    constructor() {
        this.routes = null;
        this.revisedPage = null;
    }

    set steps(routesData) {
        if (angular.isObject(routesData) && angular.isArray(routesData)) {
            this.routes = this.routes || {};

            routesData.forEach((route) => {
                this.routes = this.routes || {};
                this.routes[route.page] = route;
                this.routes[route.page].revisedPage = this.getRevisedPage(route);
            });

        } else {
            this.routes = null;
        }
    }

    /**
     * @ngdoc method
     * @name getRevisedPage
     * @methodOf BB.Services:bbWidgetRoutes
     * @description
     *
     *
     * @param {object} route The given information for the route inside the setRoutes function call
     */
    getRevisedPage(route) {
        return angular.isDefined(route.version) && parseInt(route.version) > 1 ? [route.page, route.version].join('_v') : route.page;
    }
}

angular.module('BBPublicBooking').service('bbWidgetRoutes', BBWidgetRoutesService);






// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/public-booking/widget/bb_widget_routes.service.js